import type { IUserEntity } from '@4dk.dto/kit/services/user';

export const useUserStore = defineStore('userStore', () => {
  const currentUser = ref<IUserEntity | null>(null);
  const currentAvatar = ref('4dkid/storage/avatars/11cb5b39-129e-4852-b4bd-cbfa84644de9.webp');
  const displayName = computed(() => {
    if (currentUser.value?.profile_data?.f_name && currentUser.value?.profile_data?.s_name) {
      return `${currentUser.value?.profile_data?.f_name} ${currentUser.value?.profile_data?.s_name}`;
    }
    else if (currentUser.value?.profile_data?.f_name) {
      return currentUser.value?.profile_data.f_name;
    }
    else if (currentUser.value?.profile_data?.s_name) {
      return currentUser.value?.profile_data?.s_name;
    }
    else {
      return currentUser.value?.profile_data?.links.emails?.find(email => email.is_main)?.value;
    }
  });

  const setUser = (user: IUserEntity) => {
    currentUser.value = user ?? null;
    // if (currentUser.value?.personal_data?.image_avatar_url?.length) {
    //   currentAvatar.value = currentUser.value.personal_data.image_avatar_url;
    // }
  };

  const unsetUser = () => {
    currentUser.value = null;
  };

  return {
    setUser,
    unsetUser,
    currentUser,
    displayName,
    currentAvatar,
  };
});
